export const addUserData = async (email: string, address: string) => {
  if (!email || !address) return;
  const response = await fetch(`/api/add-user-email`, {
    method: "POST",
    body: JSON.stringify({ email, address: address.toLowerCase() }),
  });
  return response;
};

export const getUserProfile = async (token?: string) => {
  if (!token) return {};
  try {
    const response = await fetch(`/api/getUserProfile`);
    const json = await response.json();
    if (json.error) return {};
    return json;
  } catch (err) {
    console.error(err);
    return {};
  }
};
